module.exports = "//public.getcloudapp.com/packs/media/images/checkmark@2x-f8353e2a0dd9e990ab725905fab0a125.png";